import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../commonComponents/translate';
import RecommendationsList from './recommendations/RecommendationsList';
import Anchor from '../../../commonComponents/Anchor';
import GameProp from '../propTypes/gameProp';

function Recommendations({ t, challenge }) {
  const createURL = `/challenges/recommendations/create?gameId=${
    challenge._id
  }`;
  const hasStarted = moment.utc(challenge.startDate).isBefore(moment.utc());

  return (
    <div className="m-portlet__body">
      {hasStarted && (
        <div className="table-add-button">
          <Anchor
            className="btn btn-dynamic m-btn--pill m-btn--wide"
            href={createURL}
          >
            <i className="la la-plus" />
            {t('challengeDetails_newRecommendation')}
          </Anchor>
        </div>
      )}
      <RecommendationsList challengeId={challenge._id} />
    </div>
  );
}

Recommendations.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(Recommendations);
